export const columnsToHideForZaraPriceTicket = [
  "PRICE_CURRENCY_1",
  "PRICE_CURRENCY_2",
  "PRICE_CURRENCY_3",
  "PRICE_CURRENCY_4",
  "PRICE_QUANTITY_1",
  "PRICE_QUANTITY_2",
  "PRICE_QUANTITY_3",
  "PRICE_QUANTITY_4",
  "IMPORTER_COUNTRY_DESC",
  "IMPORTER_COUNTRY_DESC-2",
  "IMPORTER_COUNTRY_DESC-3",
  "IMPORTER_COUNTRY_DESC-4",
];

export const columnsToHideForZaraStickers = [
  "SIZE_DESC_COUNTRY_2",
  "SIZE_DESC_COUNTRY_3",
  "SIZE_DESC_COUNTRY_4",
  "SIZE_DESC_COUNTRY_6",
  "SIZE_DESC_COUNTRY_7",
  "SIZE_VALUE_COUNTRY_2",
  "SIZE_VALUE_COUNTRY_3",
  "SIZE_VALUE_COUNTRY_4",
  "SIZE_VALUE_COUNTRY_6",
  "SIZE_VALUE_COUNTRY_7",
];

export const columnsToAddForZaraPriceTicket = [
  "IS_STANDARD",
  "IS_CATEGORY",
  "IS_LICENSE",
  "IMP_DATE",
  "FACTORY_NAME",
  "FACTORY_ADDRESS",
  "SIZE_CODE",
];

export const columnsToAddForZaraStickers = [
  "INR",
  "IS_CATEGORY",
  "ORDER_DATE",
  "IMP_DATE",
  "IMP",
];
